import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from '../services/auth';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const user = getUser();
  
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.type)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;